import React, { ReactNode } from 'react';

import { isInputComponent } from '../../../helpers';

import { Header } from '../Table';

export function hasCheckbox(props): boolean {
  if (props.children) {
    return React.Children.map(
      props.children,
      child => child && child.type && (child.type.displayName === 'Checkbox' || child.type.displayName === 'Radio'),
    )[0];
  }
  return false;
}

export function hasOperators(props): boolean {
  if (props.children) {
    return Boolean(
      React.Children.map(
        props.children,
        child => child && child.type && child.type.displayName === 'Button' && child.props.operators,
      )[0],
    );
  }
  return false;
}

export function hasControl(props): boolean {
  if (props.children) {
    return Boolean(
      React.Children.map(
        props.children,
        child =>
          child &&
          isInputComponent(child) &&
          child.type.displayName !== 'Checkbox' &&
          child.type.displayName !== 'Radio' &&
          child.props.isCell,
      )[0],
    );
  }
  return false;
}

export function hasActions(props): boolean {
  if (props.children) {
    return Boolean(
      React.Children.map(
        props.children,
        child =>
          child &&
          child.type &&
          (child.type.displayName === 'Button' || child.type.displayName === 'DeprecatedDropdown'),
      )[0],
    );
  }
  return false;
}

export function hasRibbon(children: any): boolean {
  if (children) {
    return Boolean(React.Children.map(children, child => child && child.props.ribbon)[0]);
  }
  return false;
}

export function hasStripe(children: any): boolean {
  if (children) {
    return Boolean(React.Children.map(children, child => child && child.props.stripe)[0]);
  }
  return false;
}

export function getWidth(width): string | null {
  if (typeof width === 'number') return `width-${width}`;

  const numeralWidth = width.replace(/\D/g, '');

  if (width.match(/px/) && width.match(/px/).length) {
    return `width-${numeralWidth}px`;
  }
  if (numeralWidth) {
    return `width-${numeralWidth}`;
  }
  return null;
}

export const getHeadersState = headers =>
  headers.map((header, index) => {
    // We also support headers as strings and react elements
    if (typeof header === 'string' || React.isValidElement(header)) {
      return {
        label: header,
      };
    }
    return {
      ...header,
      index,
      order: header.order || null,
    };
  });

export const defineHeaders = (prevHeaders, index: number): Header[] =>
  prevHeaders.map((h, hIndex) => {
    if (hIndex === index) {
      return { ...h, order: h.order === 'ASC' ? 'DESC' : 'ASC' };
    }
    return { ...h, order: null };
  });

export function childrenWithTrigger(children: any): number {
  let count = 0;
  if (children) {
    React.Children.forEach(children, child => {
      if (child && child.props && child.props.trigger) {
        count += 1;
      }
    });
  }
  return count;
}

export function getToggledArray(children: any): ReactNode[] {
  if (children) {
    return React.Children.map(children, child => child && child.props && !!child.props.isOpen);
  }
  return [];
}

// TODO: actually type these once the scraper is updated
export function isTwiddle({ children, data, renderRow }: { children?: any; data: any; renderRow: any }) {
  return childrenWithTrigger(children || data.map((d, index) => renderRow(d, index))) > 0;
}

export function defineOffsetLeft(element: HTMLElement): number {
  if (!element.parentElement) return 0;
  const { left: parentOffsetLeft } = element.parentElement.getBoundingClientRect();
  const { left: elementOffsetLeft } = element.getBoundingClientRect();
  return elementOffsetLeft - parentOffsetLeft;
}
